import { createContext } from 'react';

export const InviteMemberContext = createContext(null);
